var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarouselNavigationArrow = function SvgCarouselNavigationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.293 16.293a1 1 0 1 0 1.414 1.414zM9 9l.707.707a1 1 0 0 0 0-1.414zM1.707.293A1 1 0 0 0 .293 1.707zm0 17.414 8-8-1.414-1.414-8 8zm8-9.414-8-8L.293 1.707l8 8z"
  })));
};
export default SvgCarouselNavigationArrow;